import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-invoice-log',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./invoice-log.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class InvoiceLogComponent extends BaseListComponent implements OnInit {
  invoiceId;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'invoice_log';
    this.title = 'log';
  }

  getBody(): any {
    const body = super.getBody();
    body['query'] = ['invoice_id', '=', this.invoiceId];
    return body;
  }

}
